import React from 'react';

export default function Button1(props) {
  return (
    <button
      style={{
        backgroundColor: 'black',
        padding: '8px 20px', // Adjust px-5 py-2
        fontSize: '12px', // Base size
        color: 'white',
        border: '2px solid black',
        borderRadius: '4px',
        fontWeight: '400', // Normal font weight
        cursor: 'pointer',
        transition: 'all 0.7s ease', // Smooth hover
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = 'transparent';
        e.target.style.color = 'black';
        e.target.style.boxShadow = '0px 4px 6px rgba(0, 0, 0, 0.2)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = 'black';
        e.target.style.color = 'white';
        e.target.style.boxShadow = 'none';
      }}
    >
      {props.btn1}
    </button>
  );
}
